import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth-context';
import { LangSwitcher } from './LangSwitcher';

export function Layout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { me, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="mx-auto max-w-5xl px-4 h-14 flex items-center gap-4">
          <Link to="/" className="font-semibold text-slate-900">
            {t('appName')}
          </Link>
          <div className="flex-1" />
          {me?.role === 'SUPER_ADMIN' && (
            <>
              <Link to="/admin/schools" className="text-sm text-slate-600 hover:text-slate-900">
                {t('nav.admin')}
              </Link>
              {/* Phase 7. Super-admin only, in the nav as well as on the route —
                  no other role has a usage view to link to. */}
              <Link to="/admin/usage" className="text-sm text-slate-600 hover:text-slate-900">
                {t('nav.usage')}
              </Link>
            </>
          )}
          {me?.role === 'SCHOOL_ADMIN' && (
            <Link to="/school/users" className="text-sm text-slate-600 hover:text-slate-900">
              {t('nav.school')}
            </Link>
          )}
          {me?.role === 'COORDINATOR' && (
            <Link to="/coordinator/teachers" className="text-sm text-slate-600 hover:text-slate-900">
              {t('nav.coordinator')}
            </Link>
          )}
          {me?.schoolName && (
            <span className="text-sm text-slate-500 hidden sm:inline">{me.schoolName}</span>
          )}
          {/* Phase 8. Every role, unconditionally — the two actions behind it
              are about the caller's own credentials, so there is no role for
              which they do not apply. */}
          {me && (
            <Link to="/account" className="text-sm text-slate-600 hover:text-slate-900">
              {t('nav.account')}
            </Link>
          )}
          <LangSwitcher />
          <button
            onClick={() => void signOut()}
            className="text-sm text-slate-600 hover:text-slate-900"
          >
            {t('nav.signOut')}
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6">{children}</main>
    </div>
  );
}

export function Loading() {
  const { t } = useTranslation();
  return <p className="text-slate-500 py-8">{t('common.loading')}</p>;
}

export function ErrorBox({ message }: { message: string }) {
  return (
    <p role="alert" className="text-red-700 bg-red-50 border border-red-200 rounded-md p-3">
      {message}
    </p>
  );
}
